import Box from '@material-ui/core/Box'
import Card from '@material-ui/core/Card'
import CardActionArea from '@material-ui/core/CardActionArea'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import { fade } from '@material-ui/core/styles/colorManipulator'
import * as React from 'react'

import Avatar from '../avatar/Avatar'
import Typography from '../base/Typography'
import Icon from '../icons/Icons'

export type AppendixCardProps = {
  title?: string
  label?: string
  onPress?(): void
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    card: {
      minWidth: theme.spacing(25),
      maxWidth: '100%',
      borderRadius: 8,
      border: `1px solid ${theme.palette.grey[600]}`
    },
    cardActionArea: {
      padding: theme.spacing(2)
    },
    cardActionAreaBox: {
      marginTop: theme.spacing(1),
      display: 'grid',
      gridColumnGap: theme.spacing(2),
      gridAutoFlow: 'column',
      gridAutoColumns: 'max-content'
    },
    cardActionAreaBoxLabel: {
      display: 'grid',
      gridColumnGap: theme.spacing(1),
      gridAutoFlow: 'column',
      alignItems: 'center',
      color: theme.palette.secondary.main
    },
    cardAvatar: {
      background: fade(theme.palette.primary.main, 0.03),
      color: theme.palette.primary.main
    }
  })
)

const AppendixCard: React.FC<AppendixCardProps> = (props) => {
  const {
    title = 'For More Information',
    label = 'View Appendix',
    onPress = () => {}
  } = props
  const classes = useStyles()
  return (
    <Card elevation={0} classes={{ root: classes.card }}>
      <CardActionArea
        classes={{ root: classes.cardActionArea }}
        onClick={onPress}
      >
        <Typography variant="overline" children={title} />
        <Box className={classes.cardActionAreaBox}>
          <Avatar className={classes.cardAvatar} customSize="medium">
            <Icon iconName="InvoiceIcon" size="small" />
          </Avatar>
          <Box className={classes.cardActionAreaBoxLabel}>
            <Typography variant="body2" children={label} />
            <Icon iconName="ArrowRightIcon" size="small" />
          </Box>
        </Box>
      </CardActionArea>
    </Card>
  )
}

export default AppendixCard
